/* eslint-disable no-nested-ternary */
import Checkbox from 'components/Checkbox/Toggle';
import DefaultAvatar from 'assets/svgs/common/default-avatar.svg';
import React, {useState} from 'react';
import AddTeamMember from 'components/AddTeamMember';
import {getYyyyMmDd} from '../../../utils/date';

const Row = ({
  member,
  handleContextMenu,
  setSelectedTeam,
  setAddTeam,
  addTeam,
  selectedTeam,
  updateUser,
  index,
  roles,
  uniqueId,
  onUpdated,
  updateBelow,
  onClear,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const [updating, setUpdating] = useState(false);
  const getClass = () => {
    if (updating) {
      return 'updating';
    }
    if (selectedTeam && selectedTeam._id === member._id) {
      return deleteConfirm
        ? 'active'
        : updating
        ? 'updating'
        : selectedTeam._id === 'new_user'
        ? 'bg-white-add'
        : 'bg-black';
    }
    return 'bg-gray4';
  };
  return (
    <>
      <tr
        className={`${getClass(member)}`}
        key={member._id}
        onContextMenu={(e) => handleContextMenu(e, {...member, index})}
        onClick={() => {
          if (!member.isActive) return;

          if (addTeam && addTeam === member._id) {
            setSelectedTeam(null);
            setAddTeam(null);
          } else {
            setSelectedTeam(member);
            setAddTeam(member._id);
          }
        }}
      >
        <td className={`bg-gray4 ${!member.isActive ? 'inactive' : ''}`}>
          {member.uniqueId}
        </td>
        <td className={`bg-gray4 ${!member.isActive ? 'inactive' : ''}`}>
          {member.name}
        </td>
        <td className={`bg-gray4 ${!member.isActive ? 'inactive' : ''}`}>
          <div className="editor-name">
            <img
              src={member.avatar ? `${member.avatar}` : DefaultAvatar}
              className="mr-2 round"
              alt=""
            />
            {member.firstName} {member.lastName}
          </div>
        </td>
        <td className={`bg-gray4 ${!member.isActive ? 'inactive' : ''}`}>
          {member.email}
        </td>
        <td className={`bg-gray4 ${!member.isActive ? 'inactive' : ''}`}>
          {getYyyyMmDd(member.createdAt)}
        </td>
        <td className={`bg-gray4 ${!member.isActive ? 'inactive' : ''}`}>
          {roles
            ? roles.map((role, i) => (
                <div key={i}>
                  <span
                    className="btn"
                    style={{
                      borderRadius: 0,
                      background: role.color,
                      color: '#fff',
                      fontSize: 12,
                      minWidth: 130,
                      height: 30,
                    }}
                  >
                    {role.title}
                  </span>
                </div>
              ))
            : '-'}
        </td>
        <td className={`bg-gray4 ${!member.isActive ? 'inactive' : ''}`}>
          {member.postCount?.toLocaleString() || '-'}
        </td>
        <td className={`bg-gray4 ${!member.isActive ? 'inactive' : ''}`}>
          {member.lastLoginAt ? getYyyyMmDd(member.lastLoginAt) : '-'}
        </td>
        <td
          aria-hidden
          className={`bg-gray4 ${!member.isActive ? 'inactive' : ''}`}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          <div className="d-flex active-deactive-btn justify-content-center">
            Active
            <Checkbox
              enabled={member.isActive}
              className="mx-2"
              handleChange={updateUser}
            />
            Inactive
          </div>
        </td>
      </tr>

      <tr className={`${getClass()} empty-row user-row`}>
        <td colSpan="9" className="edit-user-box py-3">
          <div
            className={`user-edit d-flex w-100 ${
              isOpen ? 'drop-open' : ''
            } position-relative ${deleteConfirm ? 'delete' : ''} ${
              addTeam === member._id ? 'opened' : ''
            }`}
          >
            {addTeam === member._id && (
              <AddTeamMember
                setIsOpen={setIsOpen}
                setUpdating={setUpdating}
                selectedTeam={selectedTeam}
                setDeleteConfirm={setDeleteConfirm}
                deleteConfirm={deleteConfirm}
                maxId={uniqueId}
                onUpdated={onUpdated}
                updateBelow={updateBelow}
                onCancel={(clear) => {
                  if (!clear) {
                    setAddTeam(null);
                  } else {
                    onClear();
                  }
                }}
                onRefresh={() => {
                  // dispatch(getTeamMembers());
                }}
              />
            )}
          </div>
        </td>
      </tr>
    </>
  );
};

export default Row;
